import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, right }) {
  return (
    <header className="px-6 md:px-10 pt-8 md:pt-10 pb-6 md:pb-8 border-b border-white/10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          {eyebrow && (
            <div className="font-mono-alt text-[10px] text-white/40 tracking-widest uppercase mb-2">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] text-white leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-white/50 text-sm md:text-base max-w-2xl">{subtitle}</p>
          )}
        </div>
        {right && <div className="flex-shrink-0">{right}</div>}
      </div>
    </header>
  );
}
